// React
import * as React from 'react'
import * as ReactDOM from 'react-dom'
import registerServiceWorker from './registerServiceWorker'


if (process.env.REACT_APP_STAGE === 'prod') {
  // Disable console.log in production
  console.log = () => {
    return null;
  };
}

// Components
import { stores } from './stores'

// Package
import { Provider } from 'mobx-react'

// Patch moment duration
import 'moment-duration-format'

// CSS
import 'bootstrap/dist/css/bootstrap.css'
import 'src/assets/css/fonts.css'
import App from './App' 

ReactDOM.render(
  <Provider {...stores}>
    <App />
  </Provider>,
  document.getElementById('root') as HTMLElement,
)
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.tsx